import { AnyFunction, AsyncFunction } from '@typings';

export const noop: AnyFunction = () => {};

export const noopAsync: AsyncFunction = async () => {};
